import { render, staticRenderFns } from "./CompanySummary.vue?vue&type=template&id=17c4dad7"
import script from "./CompanySummary.vue?vue&type=script&lang=js"
export * from "./CompanySummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports